import React from 'react'

import { reverse } from 'named-urls'
import { useLocation, Link } from 'react-router-dom'

import {
  Box,
  Typography,
  Button,
  makeStyles,
  CircularProgress,
} from '@material-ui/core'

import { routes } from 'routes'
import * as service from 'service'
import ClientContext from 'contexts/ClientContext'
import useFetch from 'hooks/useFetch'
import helpers from 'helpers'
import styles from './styles'

const useStyles = makeStyles(styles)

export default function Finish() {
  const { handleReset, data, setActiveStep } = React.useContext(ClientContext)
  const classes = useStyles()
  const location = useLocation()

  const { response, error, isLoading } = useFetch(
    service.recurrence.customers.create,
    { ...data, contactAttributes: helpers.people.convertPhoneApi(data.phone) },
  )

  const path = React.useMemo(() => {
    if (location.state?.from) {
      return {
        pathname: location.state.from,
        state: {
          ...location.state,
          data: {
            customer: response?.data.customer,
          },
        },
      }
    }
    if (location.state) {
      return {
        pathname: routes.contracts.new,
        state: {
          ...location.state,
          contract: {
            ...location.state.contract,
            customer: response?.data.customer,
          },
        },
      }
    }
  }, [location.state, response])

  const showFirstStep = () => {
    setActiveStep(0)
  }

  const SuccessOrigin = () => (
    <>
      <Typography variant="h3" className={classes.title}>
        Cliente cadastrado com sucesso!
      </Typography>
      <div className={classes.buttonGroup}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          component={Link}
          to={path}
          fullWidth
        >
          Continuar{' '}
          {location.state.from ? location.state.destination : 'assinatura'}
        </Button>
        <Button
          className={classes.button}
          component={Link}
          to={routes.contracts.all}
          fullWidth
        >
          Cancelar
        </Button>
      </div>
    </>
  )

  const SuccessDefault = () => (
    <>
      <Typography variant="h3" className={classes.title}>
        Cliente cadastrado com sucesso!
      </Typography>
      <div className={classes.buttonGroup}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          component={Link}
          to={reverse(routes.clients.show, {
            clientId: response.data.customer.id,
          })}
          fullWidth
        >
          Visualizar
        </Button>
        <Button onClick={handleReset} className={classes.button} fullWidth>
          Adicionar novo
        </Button>
      </div>
    </>
  )

  const Success = () =>
    !!location?.state ? <SuccessOrigin /> : <SuccessDefault />

  const Error = () => (
    <>
      <Typography variant="h3" className={classes.title}>
        Ops! Ocorreu algum erro!
      </Typography>
      <div className={classes.buttonGroup}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={showFirstStep}
          fullWidth
        >
          Tentar novamente
        </Button>
        <Button
          className={classes.button}
          component={Link}
          to={routes.clients.all}
          fullWidth
        >
          Cancelar cadastro
        </Button>
      </div>
    </>
  )

  const ShowResult = () => (error ? <Error /> : <Success />)

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      {isLoading ? <CircularProgress size={40} /> : <ShowResult />}
    </Box>
  )
}
